let port = "https://www.ihuizong.cn";                //  正式库接口前缀
// let port = 'http://192.168.0.150';                // 测试
// let port = "http://www.renli.cn";                //  龙平
let urlPrefix = port + '/officially/api.';
export default ({
    apiUrl: {

        pwdLogin: urlPrefix + 'Login/pwdLogin', //登录
        register: urlPrefix + 'Login/register', //注册
        getAgreement: urlPrefix + 'Webinfo/getJoinContract', //注册协议
        sendsms: urlPrefix + 'Login/sendsms', //短信验证码
        verificationCode: urlPrefix + 'Login/recode', //忘记密码-验证码验证 下一步
        setNewPwd: urlPrefix + 'Login/setNewPwd', //设置新密码

        getIndex: urlPrefix + 'Pagehome/getInfo', //获取首页信息
        getService: urlPrefix + 'Pagecommodity/getInfo', //获取产品服务信息

        getHot: urlPrefix + 'Commodity/getHot', //头部商品信息

        getList: urlPrefix + 'Commodity/getList', //商品列表
        addCart: urlPrefix + 'Commoditycart/addCart', //添加到购物车

        // 功能列表
        getPriceList: urlPrefix + 'Servicepackage/getList', //功能列表

        // 购物车
        getShopCart: urlPrefix + 'Commoditycart/getList', //获取购物车商品信息
        AddList: urlPrefix + 'Address/add', //添加用户地址
        getAddList: urlPrefix + 'Address/getList', //获取用户地址列表
        updateAdd: urlPrefix + 'Address/update', //修改用户收货地址
        delAddId: urlPrefix + 'Address/delById', //修改用户收货地址
        saveDefault: urlPrefix + 'Address/saveDefault', //设置默认收货地址
        delShopCart: urlPrefix + 'Commoditycart/delCart', //删除购物车商品
        setOrder: urlPrefix + 'Ordercommodity/setOrder', //立即支付

        getEquipment: urlPrefix + 'Pagecommodity/getEquipment', //智能设备
        serviceBasic: urlPrefix + 'Pagecommodity/serviceBasic', //功能列表页

        // 帮助与支持
        helpBasic: urlPrefix + 'Pagecommodity/helpBasic', //帮助与支持 头部图片等
        getHelpType: urlPrefix + 'Helpme/getType', //帮助与支持 分类列表
        getTitleListByTypeId: urlPrefix + 'Helpme/getTitleListByTypeId', //获取文章列表
        getHelpContent: urlPrefix + 'Helpme/getContentById', //帮助与支持 内容
        helpSearch: urlPrefix + 'Helpme/LikeTitle', //帮助与支持 搜索

        getBasic: urlPrefix + 'Pagemy/getBasic', //关于我们

        getAgentBasic: urlPrefix + 'Pagemy/getAgentBasic', //加盟代理
        commitApply: urlPrefix + 'Agentapply/commitApply', //申请加盟




        // 个人中心
        getMyPack: urlPrefix + 'Servicepackage/getMyPack', //服务版本
        getOrderList: urlPrefix + 'Ordercommodity/getOrderList', //我的订单
        getMyAttribute: urlPrefix + 'User/getMyAttribute', //获取我的信息
        updataMyInfo: urlPrefix + 'User/telfixed', //更新我的信息
        savePwd: urlPrefix + 'User/savePwdByOldPwd', //修改密码
        headLoadBase: urlPrefix + 'User/headLoadBase64', //上传头像
    },
    globalParam: {
        access_token: window.localStorage.getItem("access_token")
    },

    // 公共方法
    commonFun: {
        // 返回本地缓存的值
        getStorageVal: function (name) {
            var val = val;
            var newVal = window.localStorage.getItem(name);
            return newVal;
        },
        // 设置本地缓存值  param : name - key string   val - value  - object,number,string
        setStorageVal: function (name, val) {
            var val = val;
            var newVal = window.localStorage.setItem(name, val);
            return newVal;
        },
        clearStorageVal: function (name, val) {
            window.localStorage.removeItem(name);
        },
        // ajax(dom,url,param,callback,type){
        ajax(jsonObj) {
            var jsonObj = jsonObj;
            var dom = jsonObj.dom || "";
            var type = jsonObj.type || "get";
            var url = jsonObj.url || "";
            var param = jsonObj.data || {};
            var success = jsonObj.success || function () {
            };
            var isLoding = jsonObj.isLoding || false;
            var isLodingTit = jsonObj.isLodingTit || "数据加载中";
            var error = jsonObj.error || function (response) {
                if (response.data) {
                    dom.$Message.config(response.data.msg || "请求数据错误，联系管理员1");
                } else {
                    dom.$Message.config(response.msg || "请求数据错误，联系管理员2");
                }
            };
            param.access_token = window.localStorage.getItem("access_token") || "";
            if (dom == "") {
                alert("this必填");
                return;
            }
            if (url == "") {
                dom.$Message.config("请求地址必填");
                return;
            }
            if (isLoding) {
                dom.$Message.loading({
                    mask: true,
                    message: isLodingTit,
                    duration: 0
                });
            }

            if (type == "get") {
                dom.$ajax.get(url, {
                    params: param
                }).then(response => {
                    if (response.data.code == 0) {
                        var data = response.data.data;
                        success(data, response.data);
                    } else {
                        if (response.data.code == 1001) {
                            window.localStorage.removeItem("access_token");
                            dom.$router.push('/login');
                            dom.$Message.error(response.data.msg);
                        } else {
                            error(response);
                        }
                    }
                    if (isLoding) {
                        dom.$Message.destroy();
                    }
                }).catch(response => {
                    error(response);
                    if (isLoding) {
                        dom.$Message.destroy();
                    }
                });
            } else {
                dom.$ajax.post(url, dom.$qs.stringify(param)).then(response => {
                    if (response.data.code == 0) {
                        var data = response.data.data;
                        success(data, response.data);
                    } else {
                        if (response.data.code == 1001) {
                            window.localStorage.removeItem("access_token");
                            dom.$router.push('/login');
                            dom.$Message.error(response.data.msg);
                        } else {
                            error(response);
                        }
                    }
                    if (isLoding) {
                        dom.$Message.destroy();
                    }
                }).catch(response => {
                    error(response)
                    if (isLoding) {
                        dom.$Message.destroy();
                    }
                })
            }
        }
    },
})



// WEBPACK FOOTER //
// ./src/assets/js/common.js